export const MarketingAnalyticsEvents = {
  ctaClicked: "cta_clicked",
  pricingTierViewed: "pricing_tier_viewed"
} as const;

export const AdminAnalyticsEvents = {
  adminSignedIn: "admin_signed_in",
  workspaceCreated: "workspace_created",
  apiKeyCreated: "api_key_created",
  policyCreated: "policy_created",
  policyUpdated: "policy_updated",
  approvalDecision: "approval_decision",
  billingCheckoutStarted: "billing_checkout_started",
  connectorInstalled: "connector_installed"
} as const;

export type MarketingAnalyticsEventName =
  (typeof MarketingAnalyticsEvents)[keyof typeof MarketingAnalyticsEvents];

export type AdminAnalyticsEventName =
  (typeof AdminAnalyticsEvents)[keyof typeof AdminAnalyticsEvents];

export type AnalyticsEventName =
  | MarketingAnalyticsEventName
  | AdminAnalyticsEventName
  | "$pageview";
